import { render, staticRenderFns } from "./realTime.vue?vue&type=template&id=55945767&scoped=true"
import script from "./realTime.vue?vue&type=script&lang=js"
export * from "./realTime.vue?vue&type=script&lang=js"
import style0 from "./realTime.vue?vue&type=style&index=0&id=55945767&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55945767",
  null
  
)

export default component.exports